/**
 * Arlo & Co — Input Auto-fit
 * Dynamically shrinks the font size of personalisation text inputs
 * so the text always fills the full width of the input box.
 * Works with custom fonts loaded via FontFace / @font-face.
 */

(function () {
  'use strict';

  // Measure text width using a canvas (fast, no DOM reflow)
  const _canvas = document.createElement('canvas');
  const _ctx = _canvas.getContext('2d');

  function measureText(text, fontFamily, fontSize) {
    _ctx.font = `${fontSize}px ${fontFamily}`;
    return _ctx.measureText(text || ' ').width;
  }

  function fitInput(input) {
    if (input.tagName === 'TEXTAREA') return; // paragraphs keep fixed size

    const maxSize = parseFloat(input.dataset.arloMaxFs) || 48;
    const minSize = 10;
    const hPad = 32;  // approximate horizontal padding inside input
    const vPad = 12;  // breathing room top+bottom for script font ascenders

    const availableWidth = input.clientWidth - hPad;
    const availableHeight = input.clientHeight > 0 ? input.clientHeight - vPad : Infinity;
    if (availableWidth <= 0) return;

    const fontFamily = getComputedStyle(input).fontFamily || 'sans-serif';
    const text = input.value || input.placeholder || '';

    let size = maxSize;

    // Shrink to fit width
    while (size > minSize && measureText(text, fontFamily, size) > availableWidth) {
      size -= 0.5;
    }

    // Shrink to fit height — script fonts have tall ascenders, use 1.2× factor
    while (size > minSize && size * 1.2 > availableHeight) {
      size -= 0.5;
    }

    input.style.fontSize = size + 'px';
    input.style.lineHeight = '1';
  }

  function initInputs() {
    document.querySelectorAll('[data-custom-option-input]').forEach(function (input) {
      if (input.tagName !== 'INPUT' || input.type !== 'text') return;

      // Store the CSS-set font size as the max (set by arlo-input-styles.css)
      const computedSize = parseFloat(getComputedStyle(input).fontSize) || 48;
      input.dataset.arloMaxFs = computedSize;

      // Initial fit
      fitInput(input);

      // Refit on every keystroke
      input.addEventListener('input', function () { fitInput(this); });
    });
  }

  // Expose fitInput globally so arlo-font-selector.js can call it directly
  window._arloFitInput = fitInput;

  // Wait for custom fonts to be ready before measuring
  document.addEventListener('DOMContentLoaded', function () {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initInputs);
    } else {
      initInputs();
    }
  });

})();
